/* JC quiet quick-add — single-variant AJAX add straight to the Dawn cart drawer. */
class JcQuickAdd extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  onSubmit(event) {
    event.preventDefault();
    if (!this.button || this.button.getAttribute('aria-disabled') === 'true') return;
    this.button.setAttribute('aria-disabled', 'true');
    this.button.classList.add('is-loading');

    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData(this.form);
    if (cartDrawer) {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
    }

    const addUrl =
      (window.routes && window.routes.cart_add_url) ||
      ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.flash(response.description || response.message || 'Sorry, this could not be added.');
          return;
        }
        if (cartDrawer && response.sections) {
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          } else {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.open && cartDrawer.open();
          }
        } else {
          const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          window.location.href = cartUrl;
        }
        this.flash('Added', true);
      })
      .catch(() => this.flash('Something went wrong. Please try again.'))
      .finally(() => {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('is-loading');
      });
  }

  flash(message, ok) {
    if (!this.button) return;
    const label = this.button.querySelector('.vio-card__qa-text');
    if (!label) return;
    const original = this.dataset.label || label.textContent;
    this.dataset.label = original;
    label.textContent = message;
    this.button.classList.toggle('is-ok', !!ok);
    clearTimeout(this._t);
    this._t = setTimeout(() => {
      label.textContent = original;
      this.button.classList.remove('is-ok');
    }, 1600);
  }
}
if (!customElements.get('jc-quick-add')) customElements.define('jc-quick-add', JcQuickAdd);
